// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
// Merges fields into the logged-in user (client phone verification: the sync's answer).
export const UPDATE_USER = 'UPDATE_USER';
